module.exports = "https://static.wmbcdn.com/uniweb/images/a99556584874d7fbae12be6ce78a54c1.png";